import { lazy } from 'solid-js'
import { messages } from '../../pages/property-new-page/property-new-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/property-new-page/property-new-page.jsx')),
    path: '/property/new',
    requiredMode: 'host',
    showFooter: false,
    showFullWidthHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}
